import { MdOutlineLogout } from "react-icons/md";
import { useDispatch } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { logout } from "../store/Slices/AuthSlice";
import "../styles/SideMenu.css";
import { sideMenuList } from "../utils/helper";
import { images } from "../utils/images";
import { collapsableIcon } from "../utils/svgs";

const SideMenu = ({ collapse, setCollapse }) => {
  const { pathname } = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const userDetails = JSON.parse(localStorage.getItem("fms-maintenance-details"));
  const userSidebar = userDetails ? userDetails?.user_sidebar : [];

  const activeTab = (sidebar) => {
    return sidebar.slug === pathname.split('/')[1] || sidebar.url === pathname || sidebar.url === `/${pathname}` || sidebar.slug === pathname || `/${sidebar.slug}` === pathname || `/${pathname.split('/')[1]}` === sidebar.url ? "active" : "";
  }

  const handleLogout = () => {
    dispatch(logout());
    localStorage.clear();
    navigate('/')
    // window.location.href = "/";
  };

  return (
    <>
      <div
        id="mainLogoWhite"
        style={{ position: "relative", justifyContent: !collapse ? "flex-start" : "center" }}
        onMouseEnter={e => {
          if (collapse) {
            const img = document.getElementById("mainLogoImg");
            const icon = document.getElementById("collapseHoverIcon");
            if (img) img.style.visibility = "hidden";
            if (icon) icon.style.visibility = "visible";
            if (icon) icon.style.display = "block";
          }
        }}
        onMouseLeave={e => {
          if (collapse) {
            const img = document.getElementById("mainLogoImg");
            const icon = document.getElementById("collapseHoverIcon");
            if (img) img.style.visibility = "visible";
            if (icon) icon.style.visibility = "hidden";
            if (icon) icon.style.display = "none";
          }
        }}
      >
        <img
          id="mainLogoImg"
          src={images.ajclLogo}
          alt="Logo"
          style={{
            display: "block",
            visibility: !collapse ? "visible" : "inherit"
          }}
        />
        {
          !collapse &&
          <div>
            <h3>{userDetails ? userDetails.username : "User"}</h3>
            <p>{userDetails ? userDetails.email : "Email"}</p>
          </div>
        }
        <span
          id="collapseHoverIcon"
          className={collapse ? "collapsable_icon collapsed" : "collapsable_icon"}
          onClick={() => setCollapse(!collapse)}
          style={{
            visibility: collapse ? "hidden" : "visible",
            display: collapse ? "none" : "block",
            zIndex: 2
          }}
          title={collapse ? "Open Sidebar" : "Close Sidebar"}
        >
          {collapsableIcon}
        </span>
      </div>

      <div className="side_menu_list">
        {userSidebar && userSidebar.map((sidebar, i) => (
          <div key={i} className={activeTab(sidebar)}>
            {sidebar?.permissions && sidebar?.permissions.length > 0 && (
              <Link
                to={sidebar?.slug?.startsWith('/') ? sidebar?.slug : `/${sidebar?.slug}`}
                className={collapse ? "collapsed_icon" : ""}
              >
                <img src={`${process.env.REACT_APP_API_FILES_URL}${sidebar?.icon}`} alt="" />
                {!collapse && <span style={{lineHeight: "0"}}>{sidebar?.menu}</span>}
              </Link>
            )}
          </div>
        ))}
        {userDetails?.my_role?.slug === "super-admin" && (
          <>
            {sideMenuList?.map((sidebar, i) => (
              <div key={i} className={activeTab(sidebar)}>
                <Link to={`${sidebar?.url}`} key={i} className={collapse ? "collapsed_icon" : ""}>
                  {sidebar?.icon}
                  {!collapse && <span style={{lineHeight: "0"}}>{sidebar?.heading}</span>}
                </Link>
              </div>
            ))}
          </>
        )}
        <div className="logout">
          <Link to="#" onClick={handleLogout} className={collapse ? "collapsed_icon" : ""}>
            <MdOutlineLogout fontSize={"20px"} />
            {!collapse && <span>Logout</span>}
          </Link>
        </div>
      </div>
    </>
  );
};

export default SideMenu;
